import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const LocationEditWrapper = ({ match, history }) => {
  const editRef = React.useRef(null)

  const token = window.localStorage.getItem('auth-token')
  const { operator } = React.useContext(AppContext)
  const { locationID } = match.params

  React.useEffect(() => {
    if (editRef.current) {
      editRef.current.locationId = locationID
    }
  }, [locationID])

  React.useEffect(() => {
    const onLocationUpdated = () => {
      // Navigate back to the view page (strip /edit from the path)
      const viewPath = match.url.replace(/\/edit$/, '')
      history.push(viewPath)
    }
    window.addEventListener('location-updated', onLocationUpdated)
    return () => window.removeEventListener('location-updated', onLocationUpdated)
  }, [match.url, history])

  if (!operator.id) {
    return (
      <div className='index locations'>
        <p>waiting for operator...</p>
      </div>
    )
  }

  const apiHost = `https://operators.${env()}.credlock.net`

  return (
    <div className='index locations'>
      {/* eslint-disable-next-line */}
      <h1></h1>
      <cl-update-location
        ref={editRef}
        apiHost={apiHost}
        operatorId={operator.id}
        token={token}
        mountPath={match.url}
      />
    </div>
  )
}

export default LocationEditWrapper
